import ApplicationController from '../../../../javascript/controllers/application_controller'

export default class extends ApplicationController {
  static targets = [
    'checkbox',
    'item',
    'itemTemplate',
    'selectedList',
    'emptyState',
    'countDisplay',
    'count',
    'selectAllCheckbox',
    'kraSupplierCheckbox'
  ]

  SHOWN_ITEMS_LIMIT = 5

  connect() {
    this.updateSelectedList()
  }

  handleCheckboxChange() {
    this.updateSelectedList()
  }

  toggleKraSupplier({ target: { checked } }) {
    for (const checkbox of this.checkboxTargets) {
      if (checkbox.getAttribute('data-kra-supplier') === 'true') {
        checkbox.checked = checked
      }
    }
  }

  get selectedItems() {
    // Storing the property value in a constant variable, so the property lookup happens just once
    const checkboxTargets = this.checkboxTargets
    const itemTargets = this.itemTargets
    const selectedItems = []

    for (let i = 0, len = checkboxTargets.length; i < len; i++) {
      const itemIsSelected = checkboxTargets[i].checked
      if (!itemIsSelected) continue

      selectedItems.push(itemTargets[i].textContent.trim())
    }
    return selectedItems
  }

  renderList() {
    const fragment = document.createDocumentFragment()
    const itemTemplate = this.itemTemplateTarget.content

    this.selectedItems.forEach((item) => {
      const itemEl = itemTemplate.cloneNode(true)
      itemEl.firstElementChild.textContent = item
      fragment.appendChild(itemEl)
    })
    this.selectedListTarget.appendChild(fragment)
  }

  clearList() {
    this.selectedListTarget.innerHTML = ''
  }

  countList(selectedCount) {
    if (selectedCount > this.SHOWN_ITEMS_LIMIT) {
      this.countTarget.textContent = selectedCount
      this.countDisplayTarget.classList.remove('hidden')
      this.selectedListTarget.classList.add('hidden')
    } else {
      this.countDisplayTarget.classList.add('hidden')
      this.selectedListTarget.classList.remove('hidden')
    }
  }

  updateSelectedList() {
    // Calculate once, use many times
    const selectedItems = this.selectedItems
    const selectedCount = selectedItems.length

    this.emptyStateTarget.classList.toggle('hidden', selectedCount > 0)
    this.selectedListTarget.classList.toggle('hidden', selectedCount === 0)

    if (selectedCount === 0) {
      this.countDisplayTarget.classList.add('hidden')
      return
    }

    this.clearList()
    this.countList(selectedCount)
    this.renderList(selectedItems)
  }

  syncSelectCheckboxes() {
    const allSelected = this.#allSelected
    this.selectAllCheckboxTarget.checked = allSelected
    this.selectAllCheckboxTarget.indeterminate =
      !allSelected && this.#someSelected

    if (this.hasKraSupplierCheckboxTarget) {
      const allKraSupplierSelected = this.#allKraSupplierSelected

      this.kraSupplierCheckboxTarget.checked = allKraSupplierSelected
      this.kraSupplierCheckboxTarget.indeterminate =
        !allKraSupplierSelected && this.#someKraSupplierSelected
    }
  }

  get #allSelected() {
    return this.checkboxTargets.every((checkbox) => checkbox.checked)
  }

  get #someSelected() {
    return this.checkboxTargets.some((checkbox) => checkbox.checked)
  }

  get #allKraSupplierSelected() {
    return this.#kraSupplierCheckboxes.every((checkbox) => checkbox.checked)
  }

  get #someKraSupplierSelected() {
    return this.#kraSupplierCheckboxes.some((checkbox) => checkbox.checked)
  }

  get #kraSupplierCheckboxes() {
    if (this._kraSupplierCheckboxes) return this._kraSupplierCheckboxes

    this._kraSupplierCheckboxes = this.checkboxTargets.filter(
      (checkbox) => checkbox.getAttribute('data-kra-supplier') === 'true'
    )

    return this._kraSupplierCheckboxes
  }
}
